export default __webpack_public_path__ + "static/img1-edf64df9166f66234c2d38f440ad42bc.png";